<template lang="html">
    <div class="view-site">

        <PageTitle
            text="Mon site">
        </PageTitle>

        <div class="layout-width padding" v-if="userSite">
            <p>J'enregistre les moteurs présents sur mon site et pouvant nécessiter un audit.</p>
            <el-alert
                v-if="siteRelatedMotors.length >= 200"
                title="Limite de 200 moteurs"
                description="Vous avez atteint la limite de 200 moteurs à renseigner, supprimez des moteurs pour en définir de nouveaux."
                type="warning"
                show-icon>
            </el-alert>
            <router-link
                v-else
                :to="{ name: 'Motor' }">
                <el-button
                    icon="el-icon-plus"
                    type="primary">
                    Ajouter un moteur
                </el-button>
            </router-link>
        </div>

        <div
             v-if="userSite"
            class="layout-width padding"
            style="margin-bottom:20px;"
        >
            <div class="shadow">
                <el-table
                    :data="siteRelatedMotors"
                    style="width: 100%">
                    <el-table-column
                        prop="name"
                        label="Nom">
                    </el-table-column>
                    <el-table-column
                        :formatter="dateCreated"
                        label="Création">
                    </el-table-column>
                    <el-table-column
                        :formatter="dateModified"
                        label="Modification">
                    </el-table-column>
                    <el-table-column
                        label="Actions"
                        width="250px">
                        <template slot-scope="scope">
                            <el-button-group>
                                <el-button
                                    size="mini"
                                    type="primary"
                                    icon="el-icon-edit"
                                    @click="edit(scope.row)">
                                Éditer
                                </el-button>
                                <el-button
                                    size="mini"
                                    type="danger"
                                    icon="el-icon-delete"
                                    @click="archive(scope.row)">
                                Supprimer
                                </el-button>
                            </el-button-group>
<!--                             <el-button
                                size="mini"
                                icon="el-icon-delete"
                                @click="remove(scope.$index, scope.row)">
                            </el-button> -->
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>

        <el-dialog
            :visible.sync="confirmDialog"
            :before-close="() => { motorUidToDelete = '' }"
            title="Supprimer"
            width="30%">
            <span>Confirmer la suppression du moteur <strong v-if="motorToDelete">{{ motorToDelete.name }}</strong></span>
            <span
                slot="footer"
                class="dialog-footer">
                <el-button
                    @click="motorUidToDelete = ''">
                    Annuler
                </el-button>
                <el-button
                    type="primary"
                    @click="confirmDelete">
                    Confirmer
                </el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import PageTitle from '@/components/partials/ui/PageTitle';
import moment from 'moment';
import { mapGetters } from 'vuex';
export default {
    name: 'Site',
    components: {
        PageTitle
    },
    data () {
        return {
            motorUidToDelete: ''
        };
    },
    computed: {
        ...mapGetters([
            'siteRelatedMotors',
            'currentSite',
            'motorByUid',
            'currentUser',
        ]),
        userSite () {
            if (this.currentSite){
                return this.currentSite
            }
            this.$router.push({name: 'Home'})
        },
        motorToDelete () {
            return this.motorUidToDelete ? this.motorByUid(this.motorUidToDelete) : null;
        },
        confirmDialog () {
            // eslint-disable-next-line
            return this.motorUidToDelete ? true : false;
        }
    },
    methods: {
        dateCreated (row) {
            return moment(row.creation_date).format('DD-MM-YYYY');
        },
        dateModified (row) {
            return moment(row.modification_date).locale('fr').fromNow();
        },
        edit (motorObj) {
            this.$router.push({ name: 'Motor', params: { motorUid: motorObj.uid } });
        },
        archive (motorObj) {
            this.$confirm(`Êtes-vous sûr(e) de vouloir supprimer le moteur ${motorObj.name} ?`, {
                    confirmButtonText: 'Confirmer',
                    cancelButtonText: 'Annuler',
                }).then(()=>{
                this.$store.dispatch('patchItem', {
                    item: {
                        archived: true,
                        url: motorObj.url,
                    },
                    model: 'motor',
                    url: this.$store.state.api.meta.listModels.motor.url,
                }).then(response => {
                    this.$store.dispatch(
                        'reloadModels',
                        {
                            motor: this.$store.state.api.meta.listModels.motor
                        }
                    ).then(response => {
                        this.$notify({
                          title: 'Supprimé',
                          message: `Le moteur ${motorObj.name} a été supprimé`,
                          type: 'success',
                          duration: 3000,
                        });
                    })
                }).catch(error => {
                    console.log(error)
                    this.$notify({
                      title: 'Erreur',
                      message: `Le moteur ${motorObj.name} n'a pas pu être supprimé`,
                      type: 'error',
                      duration: 3000,
                    });
                })
            }).catch(() => {
                return;
            })
        },
        confirmDelete () {
            this.$store.dispatch('deleteItem', {
                item: this.motorToDelete,
                model: 'motor'
            }).then(() => {
                this.motorUidToDelete = '';
                this.$notify({
                    title: 'Suppression',
                    message: 'Moteur supprimé avec succès',
                    type: 'success'
                });
            }).catch(err => {
                this.motorUidToDelete = '';
                // eslint-disable-next-line
                console.log(err);
                this.$notify({
                    title: 'Erreur',
                    message: err.message,
                    type: 'error'
                });
            });
        }
    }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/page/Motors/index.vue